(function () {
  'use strict';

  function initHeaderThree(sectionId) {
    var root = document.getElementById('GjonesHeaderThree-' + sectionId);
    if (!root) return;

    var bar = root.querySelector('.gjones-h3-bar');
    var overlay = root.querySelector('.gjones-h3-overlay');
    var drawer = root.querySelector('.gjones-h3-drawer');
    var hamburger = root.querySelector('.gjones-h3-hamburger');
    var drawerClose = root.querySelector('.gjones-h3-drawer__close');
    var drawerPanels = root.querySelectorAll('.gjones-h3-drawer__panel');
    var searchTrigger = root.querySelector('[data-h3-search-trigger]');
    var searchOverlay = root.querySelector('.gjones-h3-search');
    var searchInput = root.querySelector('.gjones-h3-search__input');
    var searchClose = root.querySelector('.gjones-h3-search__close');
    var cartTrigger = root.querySelector('[data-h3-cart-trigger]');
    var cartCount = root.querySelector('.gjones-h3-cart-count');
    var promoDismiss = root.querySelector('.gjones-h3-promo__dismiss');
    var promoBar = root.querySelector('.gjones-h3-promo');
    /* Always keep Header Three fixed at the top.
       A measured spacer preserves the header's place in normal document flow,
       so the hero starts immediately below it with no jump. */
    root.classList.add('is-sticky');
    root.classList.add('gjones-h3-fixed');

    var spacer = root.nextElementSibling;
    if (!spacer || !spacer.classList.contains('gjones-h3-fixed-spacer')) {
      spacer = document.createElement('div');
      spacer.className = 'gjones-h3-fixed-spacer';
      spacer.setAttribute('aria-hidden', 'true');
      root.parentNode.insertBefore(spacer, root.nextSibling);
    }

    function syncHeaderSpacer() {
      if (!spacer) return;
      var height = Math.ceil(root.getBoundingClientRect().height);
      spacer.style.height = height + 'px';
    }

    syncHeaderSpacer();
    requestAnimationFrame(syncHeaderSpacer);
    window.addEventListener('resize', syncHeaderSpacer, { passive: true });

    if (typeof ResizeObserver !== 'undefined') {
      var headerResizeObserver = new ResizeObserver(syncHeaderSpacer);
      headerResizeObserver.observe(root);
    }

    var lastScrollY = 0;
    var scrollRaf = null;
    var hoverTimers = {};
    var megaTimers = {};

    /* ── Fixed header scroll state ── */
    window.addEventListener('scroll', function () {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function () {
        var y = window.scrollY || window.pageYOffset;
        if (y > 40) {
          root.classList.add('is-scrolled');
        } else {
          root.classList.remove('is-scrolled');
        }
        lastScrollY = y;
        scrollRaf = null;
      });
    }, { passive: true });

    /* ── Promo bar dismiss ── */
    if (promoDismiss && promoBar) {
      promoDismiss.addEventListener('click', function () {
        promoBar.classList.add('is-hidden');
        requestAnimationFrame(syncHeaderSpacer);
        setTimeout(syncHeaderSpacer, 380);
        try {
          sessionStorage.setItem('gjones-h3-promo-dismissed-' + sectionId, '1');
        } catch (e) {}
      });

      /* Restore dismissed state */
      try {
        if (sessionStorage.getItem('gjones-h3-promo-dismissed-' + sectionId)) {
          promoBar.style.maxHeight = '0';
          promoBar.style.paddingTop = '0';
          promoBar.style.paddingBottom = '0';
          promoBar.style.opacity = '0';
          promoBar.style.pointerEvents = 'none';
          promoBar.style.overflow = 'hidden';
        }
      } catch (e) {}
    }

    /* ── Drawer helpers ── */
    function lockBody() {
      document.body.style.overflow = 'hidden';
    }

    function unlockBody() {
      document.body.style.overflow = '';
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
      hamburger && hamburger.classList.add('is-active');
      hamburger && hamburger.setAttribute('aria-expanded', 'true');
      lockBody();
      /* Focus first link after transition */
      setTimeout(function () {
        var first = drawer.querySelector('.gjones-h3-drawer__nav-link');
        if (first) first.focus();
      }, 440);
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      hamburger && hamburger.classList.remove('is-active');
      hamburger && hamburger.setAttribute('aria-expanded', 'false');
      unlockBody();
      /* Reset panels after close */
      setTimeout(function () {
        resetPanels();
      }, 420);
    }

    /* ── Drawer panel navigation ── */
    function resetPanels() {
      drawerPanels.forEach(function (panel) {
        var isRoot = panel.getAttribute('data-h3-panel') === '0';
        panel.classList.toggle('is-active', isRoot);
        panel.classList.remove('is-exit');
      });
    }

    function showPanel(id) {
      drawerPanels.forEach(function (panel) {
        var panelId = panel.getAttribute('data-h3-panel');
        if (panelId === id) {
          panel.classList.add('is-active');
          panel.classList.remove('is-exit');
        } else if (panel.classList.contains('is-active')) {
          panel.classList.remove('is-active');
          panel.classList.add('is-exit');
        }
      });
    }

    /* ── Event: hamburger ── */
    if (hamburger) {
      hamburger.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    /* ── Event: drawer close button ── */
    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    /* ── Event: overlay click ── */
    if (overlay) {
      overlay.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) closeDrawer();
        if (searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
      });
    }

    /* ── Event: drawer open-panel buttons ── */
    root.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-h3-open-panel]');
      if (openBtn) {
        e.preventDefault();
        var targetId = openBtn.getAttribute('data-h3-open-panel');
        showPanel(targetId);
        return;
      }

      var backBtn = e.target.closest('[data-h3-back-panel]');
      if (backBtn) {
        e.preventDefault();
        var backId = backBtn.getAttribute('data-h3-back-panel');
        showPanel(backId);
        return;
      }
    });

    /* ── Keyboard: Escape closes drawers ── */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        if (drawer && drawer.classList.contains('is-open')) closeDrawer();
        if (searchOverlay && searchOverlay.classList.contains('is-open')) closeSearch();
      }
    });

    /* ── Search ── */
    function openSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.add('is-open');
      overlay.classList.add('is-visible');
      lockBody();
      setTimeout(function () {
        if (searchInput) searchInput.focus();
      }, 100);
    }

    function closeSearch() {
      if (!searchOverlay) return;
      searchOverlay.classList.remove('is-open');
      if (!drawer.classList.contains('is-open')) {
        overlay.classList.remove('is-visible');
        unlockBody();
      }
      if (searchInput) {
        searchInput.value = '';
        searchInput.blur();
      }
      clearTimeout(searchDebounce);
      clearSearchResults();
    }

    if (searchTrigger) {
      searchTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (searchOverlay && searchOverlay.classList.contains('is-open')) {
          closeSearch();
        } else {
          openSearch();
        }
      });
    }

    if (searchClose) {
      searchClose.addEventListener('click', closeSearch);
    }

    /* ── Desktop nav: mega panels vs regular dropdowns ── */
    var megaNavItems = root.querySelectorAll('.gjones-h3-nav__item--mega');
    var regularNavItems = root.querySelectorAll('.gjones-h3-nav__item--has-children:not(.gjones-h3-nav__item--mega)');
    var megaPanels = root.querySelectorAll('.gjones-h3-mega--full');

    function closeAllMega() {
      megaPanels.forEach(function (panel) {
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
      megaNavItems.forEach(function (item) {
        item.classList.remove('is-open');
        var btn = item.querySelector('[aria-expanded]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    /* Mega panel items */
    megaNavItems.forEach(function (item, idx) {
      var trigger = item.querySelector('[data-h3-mega-trigger]');
      var panelKey = trigger ? trigger.getAttribute('data-h3-mega-trigger') : null;
      var panel = panelKey ? root.querySelector('[data-mega-panel="' + panelKey + '"]') : null;

      function openMega() {
        clearTimeout(megaTimers[idx]);
        /* Close regular dropdowns */
        regularNavItems.forEach(function (ri) { ri.classList.remove('is-open'); });
        /* Close other mega panels */
        closeAllMega();
        item.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        if (panel) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
        }
      }

      function closeMega() {
        megaTimers[idx] = setTimeout(function () {
          item.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel) {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
          }
        }, 120);
      }

      item.addEventListener('mouseenter', openMega);
      item.addEventListener('mouseleave', closeMega);

      /* Keep open while hovering the panel itself */
      if (panel) {
        panel.addEventListener('mouseenter', function () { clearTimeout(megaTimers[idx]); });
        panel.addEventListener('mouseleave', closeMega);
      }

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          if (window.innerWidth >= 750) {
            e.preventDefault();
            item.classList.contains('is-open') ? closeAllMega() : openMega();
          }
        });
      }
    });

    /* Regular dropdown items */
    regularNavItems.forEach(function (item, idx) {
      var link = item.querySelector(':scope > .gjones-h3-nav__link');

      function openItem() {
        clearTimeout(hoverTimers[idx]);
        closeAllMega();
        regularNavItems.forEach(function (sibling, si) {
          if (si !== idx) {
            sibling.classList.remove('is-open');
            var sibBtn = sibling.querySelector('[aria-expanded]');
            if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        if (link && link.hasAttribute('aria-expanded')) link.setAttribute('aria-expanded', 'true');
      }

      function closeItem() {
        hoverTimers[idx] = setTimeout(function () {
          item.classList.remove('is-open');
          if (link && link.hasAttribute('aria-expanded')) link.setAttribute('aria-expanded', 'false');
        }, 120);
      }

      item.addEventListener('mouseenter', openItem);
      item.addEventListener('mouseleave', closeItem);
      item.addEventListener('focusin', openItem);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeItem();
      });

      if (link) {
        link.addEventListener('click', function (e) {
          if (window.innerWidth >= 750) {
            e.preventDefault();
            item.classList.contains('is-open') ? closeItem() : openItem();
          }
        });
      }

      var subItems = item.querySelectorAll('.gjones-h3-mega__item--has-children');
      subItems.forEach(function (sub, si) {
        sub.addEventListener('mouseenter', function () {
          subItems.forEach(function (s, ssi) { s.classList.toggle('is-open', ssi === si); });
        });
        sub.addEventListener('mouseleave', function () { sub.classList.remove('is-open'); });
      });
    });

    /* Click outside to close all */
    document.addEventListener('click', function (e) {
      var inNav = e.target.closest('.gjones-h3-nav');
      var inMega = e.target.closest('.gjones-h3-mega--full');
      if (!inNav && !inMega) {
        closeAllMega();
        regularNavItems.forEach(function (item) { item.classList.remove('is-open'); });
      }
    });

    /* ── Live search preview ── */
    var searchResultsPanel = root.querySelector('.gjones-h3-search__results-panel');
    var searchContent = root.querySelector('.gjones-h3-search__content');
    var searchDebounce = null;

    function escHtml(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    function formatPrice(price) {
      if (!price && price !== 0) return '';
      var s = String(price);
      /* Already has a currency symbol — use as-is */
      if (/[^\d.,\s]/.test(s)) return s;
      /* Format using Intl with the store's active currency */
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
      try {
        var num = parseFloat(s.replace(/,/g, ''));
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, minimumFractionDigits: 2 }).format(num);
      } catch (e) {
        return s;
      }
    }

    function clearSearchResults() {
      if (searchResultsPanel) {
        searchResultsPanel.innerHTML = '';
        searchResultsPanel.classList.remove('is-visible');
      }
      if (searchContent) searchContent.style.display = '';
    }

    function renderSearchResults(products, query) {
      if (!searchResultsPanel) return;
      if (!products || products.length === 0) {
        searchResultsPanel.innerHTML = '<p class="gjones-h3-search__no-results">No results for &ldquo;' + escHtml(query) + '&rdquo;</p>';
        searchResultsPanel.classList.add('is-visible');
        if (searchContent) searchContent.style.display = 'none';
        return;
      }
      var html = '<div class="gjones-h3-search__results-header">'
        + '<span class="gjones-h3-search__section-label">Results</span>'
        + '<a href="/search?type=product&q=' + encodeURIComponent(query) + '" class="gjones-h3-search__results-all">View all &rarr;</a>'
        + '</div>'
        + '<div class="gjones-h3-search__results-grid">';
      products.forEach(function (p) {
        var imgHtml = '';
        var rawUrl = p.image
          ? (typeof p.image === 'string' ? p.image : (p.image.url || p.image.originalSrc || p.image.src || null))
          : null;
        if (rawUrl) {
          var imgSrc = rawUrl.indexOf('{width}') !== -1
            ? rawUrl.replace('{width}', '480')
            : rawUrl.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/i, '_480x$1$3');
          imgHtml = '<div class="gjones-h3-search__result-img-wrap" style="display:block;width:100%;height:150px;overflow:hidden;background:#f0f0f0;margin-bottom:10px;flex-shrink:0;">'
            + '<img src="' + imgSrc + '" alt="' + escHtml(p.title) + '" loading="lazy" class="gjones-h3-search__result-img" style="display:block;width:100%;height:150px;object-fit:cover;object-position:center top;">'
            + '</div>';
        } else {
          imgHtml = '<div class="gjones-h3-search__result-img-wrap" style="display:block;width:100%;height:150px;background:#f0f0f0;margin-bottom:10px;"></div>';
        }
        html += '<a href="' + p.url + '" class="gjones-h3-search__result-card">'
          + imgHtml
          + '<div class="gjones-h3-search__result-info">'
          + '<span class="gjones-h3-search__result-title">' + escHtml(p.title) + '</span>'
          + (p.price ? '<span class="gjones-h3-search__result-price">' + escHtml(formatPrice(p.price)) + '</span>' : '')
          + '</div></a>';
      });
      html += '</div>';
      searchResultsPanel.innerHTML = html;
      searchResultsPanel.classList.add('is-visible');
      if (searchContent) searchContent.style.display = 'none';
    }

    function fetchSearchResults(query) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(query)
        + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.resources && data.resources.results && data.resources.results.products || [];
          renderSearchResults(products, query);
        })
        .catch(function () { clearSearchResults(); });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        clearTimeout(searchDebounce);
        var q = searchInput.value.trim();
        if (q.length < 2) { clearSearchResults(); return; }
        searchDebounce = setTimeout(function () { fetchSearchResults(q); }, 280);
      });
    }

    /* ── Cart: open Shopify cart drawer if available ── */
    if (cartTrigger) {
      cartTrigger.addEventListener('click', function (e) {
        /* Try to open Dawn's built-in cart drawer */
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl && typeof cartDrawerEl.open === 'function') {
          e.preventDefault();
          cartDrawerEl.open();
        }
        /* Otherwise follow the href */
      });
    }

    /* ── Cart count live update via Shopify pubsub ── */
    if (cartCount && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
        if (data && data.cart) {
          var count = data.cart.item_count || 0;
          cartCount.textContent = count;
          cartCount.style.display = count > 0 ? '' : 'none';
        }
      });
    }

    /* Initialise: reset panels */
    resetPanels();
  }

  /* ── Init on DOMContentLoaded ── */
  function bootAll() {
    var sections = document.querySelectorAll('[data-section-type="gjones-header-three"]');
    sections.forEach(function (el) {
      initHeaderThree(el.getAttribute('data-section-id'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  /* ── Shopify editor: re-init on section events ── */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId) {
      initHeaderThree(e.detail.sectionId);
    }
  });

})();
